import React, {useEffect, useState} from 'react';
import {
    INSTAGRAM_POST_FILTER_FIELDS,
    INSTAGRAM_POST_SCHEDULE_MAP,
    LOGO_FIELD_LIST,
    SHOPIFY_PRODUCT_FIELDS_LIST
} from "../../constants/shopify.constant";
import ShowProductLink from "./show-prouct-link";
import ShowProductOptions from "./show-prouct-options";
import ProductImageSmall from "../../../pod/components/product-upload/product-image-small";
import ShowProductImages from "./show-prouct-images";
import ProductFilters from "../../../pod/components/product/product-filters";
import _ from "lodash";
import {appConfig} from "../../../firebase/client-app";
import {searchPods} from "../../../pod/services/pod-data-service";
import {searchThemes} from "../../../theme/services/theme-data-service";
import {searchDesigns} from "../../../design/services/design-data-service";
import {DEFAULT_DESIGN_DASHBOARD_TAB} from "../../../design/constants/design.constant";
import ShowEmptyListMessage from "../../../design/components/common/show-empty-list-message";
import {prepareDesignVariantLabel} from "../../../design/utils/design-variant-util";
import {searchShopifyProducts} from "../../services/shopify-product-data-service";
import RenderFields from "../../../common/ui/render-fields";
import {initiateInstagramPostSchedule, syncShopifyProducts} from "../../../common/services/cloud-function-service";
import BulkSchedulePost from "./bulk-schedule-post";
import ShowProductImageSmall from "./show-product-image-small";

const defaultFilterCriteria: any = {
    imagesUploaded: true,
    status: 'Scheduled',
    title: '',
    postDate: (new Date()).toISOString().slice(0, 10)
}

const emptyFilterCriteria: any = {
    imagesUploaded: false,
    status: 'EMPTY',
    title: '',
    postDate: ''
}

const InstagramShopifyProductList = () => {
    const [productsList, setProductsList] = useState(null);
    const [filterCriteria, setFilterCriteria] = useState(defaultFilterCriteria);
    const [dataFetchInProgress, setDataFetchInProgress] = useState(true);
    const [selectedProduct, setSelectedProduct] = useState(null);

    const getShopifyProductList = async () => {
        setDataFetchInProgress(true);

        const searchCriteriaList = [];
        // searchCriteriaList.push({field: 'instagramPost.status', condition: '==', value: 'Scheduled'});
        // searchCriteriaList.push({field: 'instagramPost.status', condition: '==', value: 'Published'});
        // searchCriteriaList.push({field: 'settings.postDate', condition: '==', value: '2022-09-13'});
        // searchCriteriaList.push({field: 'title', condition: '>=', value: 'Chasing Sunshine | Summer Quotes | Unisex Basic Softstyle T-Shirt | Gildan 64000'});
        // const productListResult = await searchShopifyProducts(searchCriteriaList, 'settings.postDate');

        _.forIn(filterCriteria, (value, attribute) => {

            if ((!_.isEmpty(value) || value === true) && value !== 'EMPTY') {
                if (attribute === 'status') {
                    searchCriteriaList.push({field: 'instagramPost.status', condition: '==', value: value});
                } else if (attribute === 'postDate') {
                    searchCriteriaList.push({field: 'settings.postDate', condition: '==', value: value});
                } else if (attribute === 'imagesUploaded') {
                    searchCriteriaList.push({field: 'settings.imagesUploaded', condition: '==', value: value});
                } else if (attribute === 'title') {
                    searchCriteriaList.push({
                        field: 'textList',
                        condition: "array-contains",
                        value: _.lowerCase(_.trim(value))
                    });
                }
            }
        });

        const productListResult = await searchShopifyProducts(searchCriteriaList);
        console.log('productListResult', productListResult);

        setProductsList(_.orderBy(productListResult, ['settings.postDate', 'settings.postTime'], ['asc', 'desc']));
        setDataFetchInProgress(false);
    }

    useEffect(() => {
        getShopifyProductList();
    }, [filterCriteria]);

    const handleFilterChanges = (event) => {
        const existingFilterCriteria = {...filterCriteria};
        const {type, name, value} = event.target;

        if (type === 'checkbox') {
            existingFilterCriteria[name] = !existingFilterCriteria[name];
        } else {
            existingFilterCriteria[name] = value;
        }

        setFilterCriteria(existingFilterCriteria);
    }

    const setProductDetailInList = (product) => {
        const existingProductList = [...productsList];
        const productIndex = _.findIndex(existingProductList, ['id', product.id]);

        if (product && selectedProduct?.id === product.id && productIndex !== -1 && product?.settings && existingProductList[productIndex]) {
            existingProductList[productIndex].settings = product.settings;
            existingProductList[productIndex].instagramPost = product.instagramPost;
            setProductsList(existingProductList);
        }
    }

    const clearFilterCriteria = () => {
        setFilterCriteria(emptyFilterCriteria);
    }

    const startInstagramPostSchedule = async (id, postDate?, postTime?) => {
        setDataFetchInProgress(true);
        await initiateInstagramPostSchedule(id, postDate, postTime);
        await getShopifyProductList();
        setDataFetchInProgress(false);
    }

    const refreshProductList = async () => {
        await getShopifyProductList();
    }

    return (
        <>

            <div className="flex justify-between">
                <div className="flex justify-start -mt-2 -ml-2 mb-2 w-full">
                    <div className="flex flex-wrap justify-start w-3/4">
                        <RenderFields
                            parentForm={filterCriteria}
                            handleDetailChanges={handleFilterChanges}
                            fieldList={INSTAGRAM_POST_FILTER_FIELDS}
                            enableEdit={true}
                            fieldClassName={'w-1/4'}/>
                    </div>

                    <div className="">
                        <button
                            onClick={() => clearFilterCriteria()}
                            className="button-small-link mt-8">
                            Clear Filters
                        </button>
                    </div>
                </div>

                <div className="text-center mt-2 w-full flex items-center justify-end">
                    <button
                        className="button-outline-green px-4 py-2"
                        onClick={() => {
                            startInstagramPostSchedule('', filterCriteria?.postDate);
                        }}>
                        <span>Post All Now</span>
                    </button>

                    <div className="ml-2">
                        <BulkSchedulePost
                            productsList={productsList}
                            refreshProductList={refreshProductList}/>
                    </div>
                </div>

            </div>

            <div className="flex justify-start">

                <div
                    className="shopify-table-container w-full overflow-y-scroll border-y border-gray-400 bg-white mt-2">

                    <ShowEmptyListMessage
                        dataList={productsList}
                        dataFetchInProgress={dataFetchInProgress}
                        label={'Shopify Products'}/>

                    {productsList?.length > 0 &&
                        <table className="w-full">
                            <thead className="">
                            <tr>
                                <th className="px-2 pb-2 border border-gray-400 sticky top-0 bg-gray-400 text-white">S.No</th>
                                {SHOPIFY_PRODUCT_FIELDS_LIST?.map((productField, rowIndex) => (
                                    <th key={`th-${rowIndex}`}
                                        className="px-2 pb-2 border border-gray-400 sticky top-0 bg-gray-400 text-white">{productField?.label}</th>
                                ))}
                                <th className="px-2 pb-2 border border-gray-400 sticky top-0 bg-gray-400 text-white">Instagram
                                    Images
                                </th>
                                <th className="px-2 pb-2 border border-gray-400 sticky top-0 bg-gray-400 text-white">Instagram
                                    Images Uploaded
                                </th>
                                <th className="px-2 pb-2 border border-gray-400 sticky top-0 bg-gray-400 text-white">Instagram
                                    Status
                                </th>
                                <th className="px-2 pb-2 border border-gray-400 sticky top-0 bg-gray-400 text-white">Instagram
                                    Schedule
                                </th>
                                <th className="px-2 pb-2 border border-gray-400 sticky top-0 bg-gray-400 text-white">
                                    Post
                                </th>
                            </tr>
                            </thead>
                            <tbody className="">
                            {productsList?.map((product, rowIndex) => (
                                <tr key={`row-${rowIndex}`} className="border border-gray-400">
                                    <td className="p-2 border border-gray-400 m-auto">
                                        <div className="flex justify-center">
                                            {rowIndex + 1}
                                        </div>
                                    </td>

                                    {SHOPIFY_PRODUCT_FIELDS_LIST?.map((productField, columnIndex) => (
                                        <React.Fragment key={`column-${rowIndex}-${columnIndex}`}>
                                            <td className="p-2 border border-gray-400 m-auto">

                                                {productField?.type !== 'list' && productField?.type !== 'object' &&
                                                    <>
                                                        {productField?.attribute === 'id' &&
                                                            <div className="text-center">
                                                                <ShowProductLink product={product}/>
                                                            </div>
                                                        }

                                                        {productField?.attribute === 'options' &&
                                                            <div className="text-center">
                                                                <ShowProductOptions product={product}/>
                                                            </div>
                                                        }

                                                        {productField?.attribute !== 'id' &&
                                                            <>{product[productField?.attribute]}</>
                                                        }
                                                    </>
                                                }

                                                {productField?.type === 'list' &&
                                                    <>
                                                        {productField?.attribute === 'options' &&
                                                            <div className="">
                                                                <ShowProductOptions product={product}/>
                                                            </div>
                                                        }

                                                        {productField?.attribute === 'images' &&
                                                            <div className="text-center">
                                                                {product?.imageFilesList && product?.imageFilesList?.length > 0 &&
                                                                    <ShowProductImageSmall
                                                                        productImageUrl={product[productField.attribute][0]?.url}
                                                                        imageDetail={product?.imageFilesList[0]}/>
                                                                }

                                                                {!(product?.imageFilesList && product?.imageFilesList?.length > 0) &&
                                                                    <ProductImageSmall
                                                                        imageUrl={product[productField.attribute][0]?.url}/>
                                                                }
                                                            </div>
                                                        }
                                                    </>
                                                }
                                            </td>
                                        </React.Fragment>
                                    ))}

                                    <td className="p-2 border border-gray-400 m-auto">
                                        <div className="flex justify-center">
                                            <ShowProductImages
                                                product={product}
                                                setSelectedProduct={setSelectedProduct}
                                                setProductDetailInList={setProductDetailInList}/>
                                        </div>
                                    </td>

                                    <td className="p-2 border border-gray-400 m-auto">
                                        <div className="flex justify-center">
                                            {product?.settings?.imagesUploaded &&
                                                <span
                                                    className="">Yes</span>
                                            }
                                        </div>
                                    </td>

                                    <td className="p-2 border border-gray-400 m-auto">
                                        <div className="flex justify-center font-bold">
                                            {product?.instagramPost?.status === 'Published' &&
                                                <span
                                                    className="text-purple-600">{product?.instagramPost?.status}</span>
                                            }
                                            {product?.instagramPost?.status === 'Scheduled' &&
                                                <span className="text-green-600">{product?.instagramPost?.status}</span>
                                            }
                                        </div>
                                    </td>

                                    <td className="p-2 border border-gray-400">
                                        <div className="text-center">
                                            <div
                                                className="font-bold text-green-700">{product?.settings?.postDate}</div>
                                            <div
                                                className="font-bold text-blue-700 ml-2">{INSTAGRAM_POST_SCHEDULE_MAP[product?.settings?.postTime]?.label}</div>
                                        </div>
                                    </td>

                                    <td className="p-2 border border-gray-400">
                                        <div className="flex justify-center">
                                            <button
                                                className="button-outline-green px-4 py-2"
                                                onClick={() => {
                                                    startInstagramPostSchedule(product?.id);
                                                }}>
                                                <span>Post Now</span>
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    }
                </div>

            </div>

        </>
    )
}

export default InstagramShopifyProductList
